import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  LOCALE_ID,
  NgModule,
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { environment } from "../environments/environment";

import {
  NgbAccordionModule,
  NgbModule,
  NgbNavModule,
} from "@ng-bootstrap/ng-bootstrap";

import { ExtrapagesModule } from "./extrapages/extrapages.module";

import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { provideTranslateService, TranslateLoader } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { initFirebaseBackend } from "./authUtils";
import { LayoutsModule } from "./layouts/layouts.module";

import { DatePipe, registerLocaleData } from "@angular/common";
import localeEn from "@angular/common/locales/en";
import localeEs from "@angular/common/locales/es";
import localePt from "@angular/common/locales/pt";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxSpinnerModule } from "ngx-spinner";
import { UiSwitchModule } from "ngx-ui-switch";
import { ToastrModule } from "ngx-toastr";
import { ErrorInterceptor } from "./core/helpers/error.interceptor";
import { FakeBackendInterceptor } from "./core/helpers/fake-backend";
import { JwtInterceptor } from "./core/helpers/jwt.interceptor";
import { LanguageService } from "./core/services/language.service";
import { WhiteLabelService } from "./core/services/whitelabel.service";
import { ThemeService } from "./core/services/theme.service";
import { ToastContainerComponent } from "./shared/isolutions-ui/feedback/notifications/toast-container.component";
import { DynamicModalComponent } from "./shared/isolutions-ui/feedback/dynamic-modal/dynamic-modal.component";

registerLocaleData(localePt, "pt-BR");
registerLocaleData(localeEn, "en-US");
registerLocaleData(localeEs, "es-ES");

if (environment.defaultauth === "firebase") {
  // initFirebaseBackend(environment.firebaseConfig);
} else {
  // tslint:disable-next-line: no-unused-expression
  FakeBackendInterceptor;
}

export function initTranslations(languageService: LanguageService) {
  return () => languageService.init();
}

export function initWhiteLabel(wlService: WhiteLabelService, themeService: ThemeService) {
  return () => {
    wlService.init();
    themeService.onThemeChange((theme) => wlService.onThemeChange(theme));
  };
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastContainerComponent,
    DynamicModalComponent,
    LayoutsModule,
    AppRoutingModule,
    ExtrapagesModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbModule,
    NgxSpinnerModule,
    ToastrModule.forRoot(),
    NgxMaskDirective,
    NgxMaskPipe,
    NgSelectModule,
    UiSwitchModule.forRoot({
      size: 'small',
      color: '#101D33',
      uncheckedLabel: '',
      checkedLabel: '',
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ...(environment.production
      ? []
      : [
          {
            provide: HTTP_INTERCEPTORS,
            useClass: FakeBackendInterceptor,
            multi: true,
          },
        ]),
    { provide: LOCALE_ID, useValue: "pt-BR" },
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService(),
    provideTranslateHttpLoader({ prefix: 'assets/i18n/', suffix: '.json' }),
    provideNgxMask(),
    {
      provide: APP_INITIALIZER,
      useFactory: initTranslations,
      deps: [LanguageService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initWhiteLabel,
      deps: [WhiteLabelService, ThemeService],
      multi: true,
    },
  ],
})
export class AppModule {}
